import classNames from "classnames";
import { useState } from "react";

import { ModalContent } from "src/app/components/modal/types";

import modalCSS from "./Modal.module.css";

const DisableModal = ({
  close,
  disableUser,
  modalContent,
}: {
  close: (isOpen: boolean) => void;
  disableUser: (entityId: number, message: string) => void;
  modalContent: ModalContent;
}) => {
  const [message, setMessage] = useState("");

  const onInputChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    const inputValue = event.target.value;

    setMessage(inputValue);
  };

  return (
    <div className={classNames("u-block", "u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", modalCSS.modal)}>
      <div className={classNames("u-h8", modalCSS.modalContentDisable)}>
        <div className="u-flex u-col12 u-flex-items-start u-flex-column">
          <div className="u-w100">
            <h3 className="u-t-primary-dark u-m0 u-mb25px">{modalContent.header}</h3>
            <p className="u-t-black u-m0 u-mb40px">
              {modalContent.text} <span className="u-t-primary">{modalContent.highlightedText}?</span>
            </p>
            <label className="u-w100 u-block u-mb5px u-ml10px">Obrazloženje</label>
            <textarea className="u-w90 u-mb40px u-outline-none" rows={10} onChange={onInputChange}>
              {message}
            </textarea>
          </div>
          <div className={classNames("u-pb0", modalCSS.disableBtnCont)}>
            <button onClick={() => close(false)} className={classNames("u-t-uppercase", "u-cursor-pointer", modalCSS.giveupBtn)}>
              odustani
            </button>
            <button
              onClick={() => disableUser(Number(modalContent.entityId), message)}
              className={classNames("u-t-uppercase", "u-cursor-pointer", modalCSS.deleteBtn)}
            >
              blokiraj
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisableModal;
